import { Box, Typography } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './FeaturedNames.module.scss';

interface FeaturedNamesProps {
    names: string[];
}

export const FeaturedNames = ({ names }: FeaturedNamesProps) => {
    useStyles(stylesheet);

    return (
        <Box className={styles.featuredNamesContainer}>
            <Box className={styles.primaryTextBoxPosition}>
                <Box className={styles.whiteTextBox}>
                    <Typography className={styles.primaryText} noWrap fontSkin="editorial-content">
                        {names[0]}
                    </Typography>
                </Box>
                <div className={styles.bngSparklesContainer}>
                    <img
                        src="https://cms.cloudinary.vpsvc.com/image/upload/c_scale,dpr_auto,f_auto,w_auto/vista-logos-pages/en-US/business-name-generator/sparkles.svg"
                        alt=""
                        loading="lazy"
                    />
                </div>
            </Box>
            <Box className={styles.secondaryTextBoxPositionOne}>
                <Box className={styles.greyTextBox}>
                    <Typography
                        className={styles.secondaryText}
                        noWrap
                        fontSkin="editorial-content"
                    >
                        {names[1]}
                    </Typography>
                </Box>
            </Box>
            <Box className={styles.secondaryTextBoxPositionTwo}>
                <Box className={styles.greyTextBox}>
                    <Typography
                        className={styles.secondaryText}
                        noWrap
                        fontSkin="editorial-content"
                    >
                        {names[2]}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
